export const REFRESH_RESUMES = 'REFRESH_RESUMES';
export const SET_RESUMES = 'SET_RESUMES';
export const ADD_RESUME = 'ADD_RESUME';
export const UPDATE_RESUME = 'UPDATE_RESUME';
export const GET_RESUME = 'GET_RESUME';
export const FINISH_GET_RESUME = 'FINISH_GET_RESUME';
export const DELETE_RESUME = 'DELETE_RESUME';
export const SET_BIO_RESUME = 'SET_BIO_RESUME';
